<template lang="pug">
  v-dialog(
      ref="dialog" 
      v-model="modal" 
      persistent
      width="90vw"
      max-width="500px"
    )
    template(v-slot:activator="{ on, attrs }")
      validation-provider(:rules="{required}" v-slot="{ errors }" :name="(label + (uniqueKey ? uniqueKey : '')) || $t('common.auction_date')")
        v-text-field(
            v-model="monthDisplay"
            :class="{'input-date-outlined': outlined, 'input-date': !outlined}"
            label="Picker in dialog"
            append-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            :disabled="disable"
            :readonly="readonly"
            :hide-details="hideDetails"
            :outlined="outlined"
            :dense="dense"
            v-next-focus:[group]
            :style="maxWidth ? `max-width: ${maxWidth}px` : ''"
            color="green"
            :clearable="clearable"
            :placeholder="placeholder"
            @click:append="modal = true"
          )
          template(v-if="isShowLabel" v-slot:label)
                span {{label || $t('common.auction_date')}}
                span.red--text(v-if="required") *
    v-date-picker(
      v-model="monthData" 
      type="month" 
      scrollable 
      full-width      
      locale="ja-jp"
      color="primary"
      :max="maxMonth"
      :min="minMonth"
      @change="modal = false, saveMonth()"
      header-color="primary")
      v-spacer
      v-btn(text color="red"  @click="modal = false") {{$t('common.cancel')}}
      v-btn(text color="primary" @click="$refs.dialog.save(monthData)") {{$t('common.ok')}}
</template>

<script>
import moment from 'moment'
import {
  defineComponent,
  ref,
  computed,
  getCurrentInstance,
  watch,
  nextTick,
  onMounted,
  onUnmounted
} from 'vue'

const CommonMonthPicker = defineComponent({
  components: {},
  props: {
    month: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    clearable: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    group: {
      type: String,
      default: 'default'
    },
    outlined: { default: false },
    dense: { default: false },
    hideDetails: { default: true },
    maxWidth: { default: null },
    formatMonth: { default: 'time_month_date' },
    minMonth: { default: '' },
    maxMonth: { default: '' },
    disable: { default: false },
    required: { default: false },
    readonly: { default: false },
    errorMessages: { type: Array, default: null },
    allowNullValue: { type: Boolean, default: false },
    placeholder: { type: String, required: false },
    isShowLabel: { type: Boolean, required: false, default: true },
    uniqueKey: { type: String, required: false }
  },
  setup(props, { emit }) {
    const { $root, $store, $toast, $refs } = getCurrentInstance().proxy
    const modal = ref(false)
    const monthFormat = ref($root.$t(`common.${props.formatMonth}`))
    const monthData = ref(props.month)
    const monthDisplay = computed(() => {
      const dateMoment = moment(monthData.value, 'YYYY-MM')
      return dateMoment._isValid ? dateMoment.format('YYYY/MM') : ''
    })
    const saveMonth = () => {
      emit('save-month', monthData.value)
    }
    onMounted(() => {
      moment.locale('ja')
    })
    onUnmounted(() => {
      $store.commit('setFirstClickDatePickerKey', null)
    })
    watch(
      () => [props.month],
      ([newMonth]) => {
        monthData.value = newMonth
      }
    )
    return { monthData, monthDisplay, modal, saveMonth }
  }
})

export default CommonMonthPicker
</script>
<style lang="sass">
.input-date-outlined .v-input__append-inner:has(.v-input__icon--append)
  position: absolute
  left: 5px
  top: 0px
.input-date-outlined input
  margin-left: 30px
.input-date-outlined .v-label
  margin-left: 30px

.input-date-outlined .v-label--active
  transform: translate(-30px, -18px) scale(0.75) !important


.input-date .v-input__append-inner:has(.v-input__icon--append)
  position: absolute
  left: -5px
  top: 1px
.input-date input
  margin-left: 30px
.input-date .v-label
  margin-left: 30px
  top: 3px !important

.input-date .v-label--active
  transform: translate(-30px, -16px) scale(0.75) !important
.date-picker .label
  position: absolute
  top: 5px
  left: 75px
  color: white
@keyframes shake
  59%
    left: 0
  60%, 80%
    left: 2px
  70%, 90%
    left: -2px
.v-input--has-state.error--text .v-label
  -webkit-animation: shake 0.6s cubic-bezier(0.25, 0.8, 0.5, 1)
  animation: shake 0.6s cubic-bezier(0.25, 0.8, 0.5, 1)
.icon-btn
  height: 22px !important
  width: 22px !important
  margin-left: 2px
.icon-label
  font-size: 22px !important
  cursor: pointer
.tooltip
  padding: 0px
  background: #4caf50 !important
  color: white !important
  font-weight: bold !important
  p
    margin-left: 16px !important
    margin-right: 16px !important
    .link
      //color: var(--v-primary-base)
      text-decoration: underline
      cursor: pointer
.menu-guide
  padding: 10px 20px 20px 20px
  box-shadow: none
  .second
    padding-bottom: 8px !important
  .v-list
    border-radius: 4px
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12) !important
  .triangle
    position: relative
    top: -9px
    left: 30px
    width: 0
    height: 0
    border-left: 10px solid transparent
    border-right: 10px solid transparent
    border-bottom: 10px solid #4caf50
.menu-guide-outlined
  margin-top: -8px
  padding: 10px 20px 20px 20px
  box-shadow: none
  .second
    padding-bottom: 4px !important
  .v-list
    border-radius: 4px
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12) !important
  .triangle
    position: relative
    top: -9px
    left: 30px
    width: 0
    height: 0
    border-left: 10px solid transparent
    border-right: 10px solid transparent
    border-bottom: 10px solid #4caf50
.confirm-container
  display: flex
  margin-left: 14px !important
  .check-box
    .v-input--selection-controls__input
      .v-icon
        color: white
    .v-label
      color: white
      display: flex
      align-items: center
      padding-top : 2px !important
  .save-container
    margin-left: 64px
    padding-top: 2px
    .save
      background-color: white
      height: 24px !important
      padding-top: 2px !important
      .v-btn__content
        color: var(--v-primary-base) !important
</style>
